(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5672],{

/***/ 61817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _BlogCard_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76680);
/* harmony import */ var _BlogCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_BlogCard_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dateformat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1280);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);






const BlogCard = (param)=>{
    let { data , id  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: "/blogs/".concat(data.slug),
        style: {
            color: "black",
            textDecoration: "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_BlogCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_BlogCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().imgContainer),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: data.cover && data.cover.data ? "https://blogcms.pillupreminder.com".concat(data.cover.data.attributes.url) : "../assets/Blogs/imgthumbnail.png"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_BlogCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tag),
                    children: data && data.category ? data.category.data.attributes.name.toUpperCase() : ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: (_BlogCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    children: data ? data.title : ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_BlogCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().date),
                    children: data ? "".concat((0,dateformat__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(data.createdAt, "longDate")) : ""
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 96424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cP": function() { return /* reexport */ components_BenefitCard; },
  "$h": function() { return /* reexport */ BlogCard/* default */.Z; },
  "$_": function() { return /* reexport */ Footer/* default */.Z; },
  "h4": function() { return /* reexport */ Header/* default */.Z; },
  "VM": function() { return /* reexport */ components_Hero; },
  "rT": function() { return /* reexport */ components_HorizontalSlider; },
  "IH": function() { return /* reexport */ components_HowItWorksSlider; },
  "wV": function() { return /* reexport */ components_Partners; }
});

// UNUSED EXPORTS: Achivements, CardSlider, FeedbackSlider, LandingSlider, PostContent, PostSlider, VideoSlider

// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(50723);
// EXTERNAL MODULE: ./components/Header.js
var Header = __webpack_require__(10292);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Hero.module.scss
var Hero_module = __webpack_require__(15769);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
// EXTERNAL MODULE: ./node_modules/gsap/index.js
var node_modules_gsap = __webpack_require__(55002);
// EXTERNAL MODULE: ./node_modules/split-type/dist/index.js
var dist = __webpack_require__(65829);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@next/font/local/target.css?{"path":"styles/fonts.ts","import":"","arguments":[{"src":[{"path":"../public/fonts/Ginger-Thin.ttf","weight":"400","style":"thin"},{"path":"../public/fonts/Ginger-Light.ttf","weight":"500","style":"light"},{"path":"../public/fonts/Ginger-Regular.ttf","weight":"600","style":"regular"},{"path":"../public/fonts/Ginger-Bold.ttf","weight":"700","style":"bold"},{"path":"../public/fonts/Ginger-Thin-Italic.ttf","weight":"400","style":"italic"},{"path":"../public/fonts/Ginger-Light-Italic.ttf","weight":"500","style":"italic"},{"path":"../public/fonts/Ginger-Italic.ttf","weight":"600","style":"italic"},{"path":"../public/fonts/Ginger-Bold-Italic.ttf","weight":"700","style":"italic"}]}],"variableName":"ginger"}
var Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_ = __webpack_require__(371);
var Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default = /*#__PURE__*/__webpack_require__.n(Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/useMobileDetect.js
var useMobileDetect = __webpack_require__(61693);
// EXTERNAL MODULE: ./constants/moEngageEvents.js
var moEngageEvents = __webpack_require__(19644);
// EXTERNAL MODULE: ./utils/helperMethods.js + 1 modules
var helperMethods = __webpack_require__(7129);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
;// CONCATENATED MODULE: ./components/Hero.js












const Hero = ()=>{
    const currentDevice = (0,useMobileDetect/* default */.Z)();
    (0,react.useEffect)(()=>{
        const text = new dist/* default */.Z("#heading-text", {
            types: "words, chars"
        });
        const animation = node_modules_gsap/* gsap.timeline */.p8.timeline();
        animation.from("#slider", {
            y: "100%",
            duration: 1.2
        }).from(text.chars, {
            opacity: 0,
            y: 30,
            duration: 1,
            delay: -0.7,
            stagger: {
                amount: 0.1
            }
        }).to("#infoHero", {
            opacity: 1,
            duration: 1,
            delay: -0.8
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "absolute",
                    width: "100vw "
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    fontBlack: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Hero_module_default()).hero,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        id: "heading-text",
                        style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                        children: [
                            "We organize, pack and deliver",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "your medicines. Simple!"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        id: "infoHero",
                        children: [
                            "Never miss a dose of your",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "medication again."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        className: "btn",
                        href: "/order",
                        rel: "noreferrer",
                        style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                        onClick: ()=>{
                            window.Moengage.track_event(moEngageEvents/* moEngageEvents.ORDER_NOW_CLICKED */.h.ORDER_NOW_CLICKED, {
                                utm_source: (0,helperMethods/* getSessionStorage */.G)(constants/* utmSourceKey */.oA),
                                utm_campaign: (0,helperMethods/* getSessionStorage */.G)(constants/* utmCampaignKey */.EA),
                                utm_medium: (0,helperMethods/* getSessionStorage */.G)(constants/* utmMediumKey */.wG),
                                Source_page: "/",
                                Source: currentDevice.isMobile() ? "mweb" : "web"
                            });
                        },
                        children: "Order Now"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Hero_module_default()).slider,
                id: "slider"
            })
        ]
    });
};
/* harmony default export */ var components_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./components/Achivements.js






const Achivements = ()=>{
    useEffect(()=>{
        const text = new SplitType("#heading-text", {
            types: "words, chars"
        });
        const animation = gsap.timeline();
        animation.from("#rightPart", {
            // x: "-100%",
            width: 0,
            duration: 0.8,
            scrollTrigger: {
                trigger: "#infoContent"
            }
        }).from("#img", {
            opacity: 0,
            duration: 0.3
        }).from("#countHeading", {
            opacity: 0,
            duration: 0.2
        }).from("#infoContent", {
            opacity: 0,
            duration: 0.2
        });
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.achiev,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.capsule,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.leftPart,
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: "/assets/Achievement/1.svg",
                            id: "img",
                            width: 90,
                            height: 90
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.rightPart,
                        id: "rightPart",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                id: "countHeading",
                                children: "+1000"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                id: "infoContent",
                                children: "Delivery"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.capsule,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.leftPart,
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: "/assets/Achievement/2.svg",
                            id: "img",
                            width: 90,
                            height: 90
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.rightPart,
                        id: "rightPart",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                id: "countHeading",
                                children: "+100000"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                id: "infoContent",
                                children: "Pouches"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.capsule,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.leftPart,
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: "/assets/Achievement/3.svg",
                            id: "img",
                            // fill
                            width: 90,
                            height: 90
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.rightPart,
                        id: "rightPart",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                id: "countHeading",
                                children: "+9000"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                id: "infoContent",
                                children: "Users"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Achivements = ((/* unused pure expression or super */ null && (Achivements)));

// EXTERNAL MODULE: ./components/Partners.module.scss
var Partners_module = __webpack_require__(57246);
var Partners_module_default = /*#__PURE__*/__webpack_require__.n(Partners_module);
;// CONCATENATED MODULE: ./public/assets/Partners/emoha.png
/* harmony default export */ var emoha = ({"src":"/_next/static/media/emoha.56cc2099.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAeUlEQVR42mOAgbtGzozobISksRMjVIIJiJkxFSF0xgBxIpxv5sDIcN/cnvGeCdwEayB2RNF1z9zBBoiN7pnbe9+ztFe6Z2GvCeQ7ALEBEOuBFEgCsTIQWwGxPhCrA7EeEEsCsRjMFBYg5gSaAsQOHEDMjmwFumtR5ADSnzQKinWupgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Partners.js




const Partners = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Partners_module_default()).partners,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                children: "Our Partners"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Partners_module_default()).cardContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Partners_module_default()).card,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Partners_module_default()).logo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "../assets/Partners/emoha.png"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Partners_module_default()).card,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Partners_module_default()).logo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "../assets/Partners/asli.png"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Partners_module_default()).card,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Partners_module_default()).logo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "../assets/Partners/meradoc.png"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Partners_module_default()).card,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Partners_module_default()).logo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "../assets/Partners/kochharcare.png"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Partners = (Partners);

// EXTERNAL MODULE: ./components/BlogCard.js
var BlogCard = __webpack_require__(61817);
// EXTERNAL MODULE: ./components/Benefit.module.scss
var Benefit_module = __webpack_require__(6222);
var Benefit_module_default = /*#__PURE__*/__webpack_require__.n(Benefit_module);
;// CONCATENATED MODULE: ./components/BenefitCard.js





const BenefitCard = (param)=>{
    let { data  } = param;
    const [isActive, setActive] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Benefit_module_default()).benefitCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Benefit_module_default()).imgContainer,
                children: [
                    data.id == "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "../assets/Why Us/card1.png"
                    }),
                    data.id == "2" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "../assets/Why Us/card2.png"
                    }),
                    data.id == "3" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "../assets/Why Us/card3.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Benefit_module_default()).contentData,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                        children: data.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: data.content
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BenefitCard = (BenefitCard); //  <div
 //       className={styles.benefitCard}
 //       // onMouseEnter={() => setActive(false)}
 //       // initial={{ x: -100, opacity: 0 }}
 //       // whileInView={{ x: 0, opacity: 1 }}
 //       // transition={{ ease: "linear" }}
 //       // viewport={{ amount: 0.8, once: true }}
 //     >
 //       <div className={styles.container}>
 //         <div className={styles.upperElipse} style={{ zIndex: 100 }}>
 //           <img src={"../assets/Why Us/card1.png"} height={200}></img>
 //         </div>
 //         <motion.div
 //           className={styles.lowerElipse}
 //           initial={{ y: -120, opacity: 0 }}
 //           whileInView={{ y: -60, opacity: 1 }}
 //           transition={{ ease: "linear" }}
 //           viewport={{ amount: 0.8, once: true }}
 //         >
 //           <p>{data.title}</p>
 //         </motion.div>
 //       </div>
 //     </div>

;// CONCATENATED MODULE: ./components/CardSlider.js


const data = [
    {
        id: 1,
        name: "Sanjana Aggarwal",
        tag: "29,Female",
        content1: "This app is a game changer for me. I am unable to go out always to buy medicinal products.",
        content2: "PillUp gives me the last liberty to shop essential healthcare products from home."
    },
    {
        id: 2,
        name: "Sanjana Aggarwal",
        tag: "29,Female",
        content1: "This app is a game changer for me. I am unable to go out always to buy medicinal products.",
        content2: "PillUp gives me the last liberty to shop essential healthcare products from home."
    },
    {
        id: 3,
        name: "Sanjana Aggarwal",
        tag: "29,Female",
        content1: "This app is a game changer for me. I am unable to go out always to buy medicinal products.",
        content2: "PillUp gives me the last liberty to shop essential healthcare products from home."
    }
];
const CardSlider = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.cardSlider,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.headingContent,
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        children: "People are loving PillUp"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.triggerBtn,
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: "/assets/BrandStory/leftArrow.svg"
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: "/assets/BrandStory/rightArrow.svg"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.sliderContainer,
                children: data.map((param)=>{
                    let { name , tag , content1 , content2 , id  } = param;
                    return /*#__PURE__*/ _jsxs("div", {
                        className: styles.card,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.cardHeadingContainer,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.cardLeft,
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: "/assets/BrandStory/commaIcon.svg",
                                            width: 20,
                                            height: 20
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.cardRight,
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: "/assets/BrandStory/user.png",
                                            width: 60,
                                            height: 60
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.cardContent,
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.headingCardContent,
                                        children: [
                                            /*#__PURE__*/ _jsx("h3", {
                                                children: name
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                children: tag
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.review,
                                        children: /*#__PURE__*/ _jsxs("p", {
                                            children: [
                                                content1,
                                                /*#__PURE__*/ _jsx("br", {}),
                                                " ",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                content2
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }, id);
                })
            })
        ]
    });
};
/* harmony default export */ var components_CardSlider = ((/* unused pure expression or super */ null && (CardSlider)));

// EXTERNAL MODULE: ./node_modules/gsap/ScrollTrigger.js + 1 modules
var ScrollTrigger = __webpack_require__(26905);
// EXTERNAL MODULE: ./components/HorizontalSlider.module.scss
var HorizontalSlider_module = __webpack_require__(50412);
var HorizontalSlider_module_default = /*#__PURE__*/__webpack_require__.n(HorizontalSlider_module);
;// CONCATENATED MODULE: ./components/HorizontalSlider.js







node_modules_gsap/* gsap.registerPlugin */.p8.registerPlugin(ScrollTrigger/* ScrollTrigger */.i);
const HorizontalSlider = ()=>{
    const panels = (0,react.useRef)([]);
    const panelsContainer = (0,react.useRef)();
    const [mobileWidth, setMobileWidth] = (0,react.useState)("");
    const createPanelsRefs = (panel, index)=>{
        panels.current[index] = panel;
    };
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth < 700) {
                setMobileWidth(true);
                // Stop the animation
                node_modules_gsap/* gsap.killTweensOf */.p8.killTweensOf(panels.current);
                node_modules_gsap/* gsap.set */.p8.set(panels.current, {
                    clearProps: "all"
                });
            } else {
                setMobileWidth(false);
                // Resume the animation if it was previously stopped
                if (panels.current.length > 0) {
                    const totalPanels = panels.current.length;
                    node_modules_gsap/* gsap.to */.p8.to(panels.current, {
                        xPercent: -100 * (totalPanels - 1),
                        ease: "none",
                        scrollTrigger: {
                            trigger: panelsContainer.current,
                            pin: true,
                            scrub: 1
                        }
                    });
                }
            }
        };
        // Add event listener for window resize
        window.addEventListener("resize", handleResize);
        // Clean up the event listener on component unmount
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0,react.useEffect)(()=>{
        const totalPanels = panels.current.length;
        if (window.innerWidth > 700) {
            node_modules_gsap/* gsap.to */.p8.to(panels.current, {
                xPercent: -100 * (totalPanels - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: panelsContainer.current,
                    pin: true,
                    scrub: 1
                }
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HorizontalSlider_module_default()).outerContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (HorizontalSlider_module_default()).container,
            ref: panelsContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (HorizontalSlider_module_default()).panel,
                    id: (HorizontalSlider_module_default()).section1,
                    ref: (e)=>createPanelsRefs(e, 0),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HorizontalSlider_module_default()).leftSection,
                            styles: {
                                color: "#FFD243"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/HorizontalSlider/1.png",
                                fill: "#6FAAFF",
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HorizontalSlider_module_default()).rightSection,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/HowItWorks",
                                    style: {
                                        color: "black"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HorizontalSlider_module_default()).howItWorksbtn,
                                        style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                        children: "How it Works"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (HorizontalSlider_module_default()).count,
                                    style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                    children: "01"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            className: (HorizontalSlider_module_default()).heading,
                                            style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                            children: [
                                                "Pre-sorted ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " Medicine Doses"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (HorizontalSlider_module_default()).info,
                                            children: "You get your medicines pre-sorted by time and date in ready to take pouches as (per your prescription plan). Time to throw away those ugly boxes."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HorizontalSlider_module_default()).scrollbtn,
                                    style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                    children: [
                                        "Scroll",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/rightArrow.svg",
                                            width: 25,
                                            alt: ""
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (HorizontalSlider_module_default()).panel,
                    id: (HorizontalSlider_module_default()).section2,
                    ref: (e)=>createPanelsRefs(e, 1),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HorizontalSlider_module_default()).leftSection,
                            styles: {
                                color: "#FFD243"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/HorizontalSlider/2.png",
                                fill: "#6FAAFF",
                                alt: "",
                                id: (HorizontalSlider_module_default()).slide2Img
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HorizontalSlider_module_default()).rightSection,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HorizontalSlider_module_default()).howItWorksbtn,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/HowItWorks",
                                        style: {
                                            color: "black"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                            style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                            children: "How it Works"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (HorizontalSlider_module_default()).count,
                                    style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                    children: "02"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            className: (HorizontalSlider_module_default()).heading,
                                            style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                            children: [
                                                "Medicine",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Reminders"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (HorizontalSlider_module_default()).info,
                                            children: "You get timely reminders from us to take your medicines on Whatsapp, PillUp app, etc. Need more?"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HorizontalSlider_module_default()).scrollbtn,
                                    style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                    children: [
                                        "Scroll",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/rightArrow.svg",
                                            width: 25,
                                            alt: ""
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (HorizontalSlider_module_default()).panel,
                    id: (HorizontalSlider_module_default()).section3,
                    ref: (e)=>createPanelsRefs(e, 2),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HorizontalSlider_module_default()).leftSection,
                            styles: {
                                color: "#FFD243"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/HorizontalSlider/3.png",
                                fill: "#6FAAFF",
                                alt: "",
                                id: (HorizontalSlider_module_default()).slide3Img
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HorizontalSlider_module_default()).rightSection,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HorizontalSlider_module_default()).howItWorksbtn,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/HowItWorks",
                                        style: {
                                            color: "black"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                            style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                            children: "How it Works"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (HorizontalSlider_module_default()).count,
                                    style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                    children: "03"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            className: (HorizontalSlider_module_default()).heading,
                                            style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                            children: [
                                                "Easy to read",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "prescription"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (HorizontalSlider_module_default()).info,
                                            children: "No need of a fancy medical degree to understand your medicine schedule"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HorizontalSlider_module_default()).scrollbtn,
                                    style: {
                                        display: "none"
                                    },
                                    children: [
                                        "Scroll",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/rightArrow.svg",
                                            width: 25,
                                            alt: ""
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_HorizontalSlider = (HorizontalSlider);

// EXTERNAL MODULE: ./components/HowItWorksSlider.module.scss
var HowItWorksSlider_module = __webpack_require__(56802);
var HowItWorksSlider_module_default = /*#__PURE__*/__webpack_require__.n(HowItWorksSlider_module);
;// CONCATENATED MODULE: ./components/HowItWorksSlider.js






node_modules_gsap/* gsap.registerPlugin */.p8.registerPlugin(ScrollTrigger/* ScrollTrigger */.i);
const HowItWorksSlider = ()=>{
    const panels = (0,react.useRef)([]);
    const panelsContainer = (0,react.useRef)();
    const [mobileWidth, setMobileWidth] = (0,react.useState)("");
    const createPanelsRefs = (panel, index)=>{
        panels.current[index] = panel;
    };
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth < 700) {
                setMobileWidth(true);
                // Stop the animation
                node_modules_gsap/* gsap.killTweensOf */.p8.killTweensOf(panels.current);
                node_modules_gsap/* gsap.set */.p8.set(panels.current, {
                    clearProps: "all"
                });
            } else {
                setMobileWidth(false);
                // Resume the animation if it was previously stopped
                if (panels.current.length > 0) {
                    const totalPanels = panels.current.length;
                    node_modules_gsap/* gsap.to */.p8.to(panels.current, {
                        xPercent: -100 * (totalPanels - 1),
                        ease: "none",
                        scrollTrigger: {
                            trigger: panelsContainer.current,
                            pin: true,
                            scrub: 1
                        }
                    });
                }
            }
        };
        // Add event listener for window resize
        window.addEventListener("resize", handleResize);
        // Clean up the event listener on component unmount
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0,react.useEffect)(()=>{
        const totalPanels = panels.current.length;
        if (window.innerWidth > 700) {
            node_modules_gsap/* gsap.to */.p8.to(panels.current, {
                xPercent: -100 * (totalPanels - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: panelsContainer.current,
                    pin: true,
                    scrub: 1
                }
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HowItWorksSlider_module_default()).outerContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (HowItWorksSlider_module_default()).container,
            ref: panelsContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (HowItWorksSlider_module_default()).panel,
                    id: (HowItWorksSlider_module_default()).section1,
                    ref: (e)=>createPanelsRefs(e, 0),
                    style: {
                        backgroundColor: "cayan"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HowItWorksSlider_module_default()).leftSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HowItWorksSlider_module_default()).contentContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (HowItWorksSlider_module_default()).count,
                                        style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                        children: "01"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: (HowItWorksSlider_module_default()).heading,
                                                style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                                children: "You complete a simple sign-up process"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (HowItWorksSlider_module_default()).info,
                                                children: "We then verify the information you share while keeping it 100% confidential"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HowItWorksSlider_module_default()).rightSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HowItWorksSlider_module_default()).imgContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/login.png",
                                    style: {
                                        height: "70%"
                                    },
                                    fill: "#6FAAFF",
                                    alt: ""
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (HowItWorksSlider_module_default()).panel,
                    id: (HowItWorksSlider_module_default()).section2,
                    ref: (e)=>createPanelsRefs(e, 1),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HowItWorksSlider_module_default()).leftSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HowItWorksSlider_module_default()).contentContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (HowItWorksSlider_module_default()).count,
                                        style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                        children: "02"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: (HowItWorksSlider_module_default()).heading,
                                                style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                                children: "Receive Confirmation Call"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (HowItWorksSlider_module_default()).info,
                                                children: "Receive Confirmation Call from our Pharmacist. They monitor the entire process end-to-end right from examining prescription to preparing your medicine sachets."
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HowItWorksSlider_module_default()).rightSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HowItWorksSlider_module_default()).imgContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/HowItWorks/phonecall.png",
                                    style: {
                                        height: "100%"
                                    },
                                    fill: "#6FAAFF",
                                    alt: ""
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (HowItWorksSlider_module_default()).panel,
                    id: (HowItWorksSlider_module_default()).section3,
                    ref: (e)=>createPanelsRefs(e, 2),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HowItWorksSlider_module_default()).leftSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HowItWorksSlider_module_default()).contentContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (HowItWorksSlider_module_default()).count,
                                        style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                        children: "03"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: (HowItWorksSlider_module_default()).heading,
                                                style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                                children: "We sort your & pack you medicines using our gold-standard machines"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (HowItWorksSlider_module_default()).info,
                                                children: "Your medicines are then packed in your personalised pouches labelled with your name, medicine name, and quantity, along with the time and date"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HowItWorksSlider_module_default()).rightSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HowItWorksSlider_module_default()).imgContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/sachet.png",
                                    style: {
                                        height: "105%"
                                    },
                                    fill: "#6FAAFF",
                                    alt: ""
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (HowItWorksSlider_module_default()).panel,
                    id: (HowItWorksSlider_module_default()).section4,
                    ref: (e)=>createPanelsRefs(e, 3),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HowItWorksSlider_module_default()).leftSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HowItWorksSlider_module_default()).contentContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (HowItWorksSlider_module_default()).count,
                                        style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                        children: "04"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: (HowItWorksSlider_module_default()).heading,
                                                style: (Ginger_Bold_Italic_ttf_weight_700_style_italic_variableName_ginger_default()).style,
                                                children: "We then dispatch your PillUp boxes to your doorstep."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (HowItWorksSlider_module_default()).info,
                                                children: "We even arrange automatic refills of your next delivery to ensure that you never run out of medication."
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HowItWorksSlider_module_default()).rightSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HowItWorksSlider_module_default()).imgContainer,
                                style: {
                                    backgroundColor: "#E5EFFB"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/HowItWorks/timeline3.png",
                                    style: {
                                        height: "50%"
                                    },
                                    fill: "#6FAAFF",
                                    alt: ""
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_HowItWorksSlider = (HowItWorksSlider);

;// CONCATENATED MODULE: ./components/LandingSlider.js




const LandingSlider = ()=>{
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.slider_container,
            children: /*#__PURE__*/ _jsxs(ReactSimplyCarousel, {
                activeSlideIndex: activeSlideIndex,
                onRequestChange: setActiveSlideIndex,
                itemsToShow: 1,
                itemsToScroll: 1,
                forwardBtnProps: {
                    className: styles.forwardBtn,
                    children: /*#__PURE__*/ _jsx("span", {
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "../assets/sliderRightArrow.svg",
                            className: styles.sliderArrow
                        })
                    })
                },
                backwardBtnProps: {
                    className: styles.backwardBtn,
                    children: /*#__PURE__*/ _jsx("span", {
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "../assets/sliderLeftArrow.svg",
                            className: styles.sliderArrow
                        })
                    })
                },
                dotsNav: {
                    show: true,
                    itemBtnProps: {
                        style: {
                            transform: "translateY(-70px)",
                            height: 12,
                            width: 12,
                            margin: "5px",
                            borderRadius: "50%",
                            border: 0,
                            background: "white"
                        }
                    },
                    activeItemBtnProps: {
                        style: {
                            transform: "translateY(-70px)",
                            height: 12,
                            width: 12,
                            backgroundColor: "#014141",
                            margin: "5px",
                            borderRadius: "50%",
                            border: 0
                        }
                    }
                },
                responsiveProps: [
                    {
                        itemsToShow: 1,
                        itemsToScroll: 1,
                        minWidth: 768
                    }
                ],
                speed: 700,
                easing: "linear",
                autoplay: true,
                autoplayDirection: "forward",
                autoplayDelay: 3000,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.panel,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                children: "Unlock a World of Convenience and Savings"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "with Pre-sorted Online Pharmacy!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.panel,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                children: "Genuine Medicine Delivered to Your Doorstep"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Ensuring your Health comes First!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.panel,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                children: "Your Trusted Destination for Discounted Medicines"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Affordable Healthcare at Your Fingertips!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.panel,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                children: "Tailored Medication Solutions"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Customized Prescriptions Just for You!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.panel,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                children: "Join the Presorted Medicine Family Today"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Your Well-Being Matters to Us!"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_LandingSlider = ((/* unused pure expression or super */ null && (LandingSlider)));

;// CONCATENATED MODULE: ./components/FeedbackSlider.js




const FeedbackSlider = ()=>{
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.slider_container,
        children: /*#__PURE__*/ _jsxs(ReactSimplyCarousel, {
            activeSlideIndex: activeSlideIndex,
            onRequestChange: setActiveSlideIndex,
            itemsToShow: 1,
            itemsToScroll: 1,
            forwardBtnProps: {
                className: styles.forwardBtn,
                children: /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "../assets/sliderRightArrowBrown.svg",
                        className: styles.sliderArrow
                    })
                })
            },
            backwardBtnProps: {
                className: styles.backwardBtn,
                children: /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "../assets/sliderLeftArrowBrown.svg",
                        className: styles.sliderArrow
                    })
                })
            },
            responsiveProps: [
                {
                    itemsToShow: 1,
                    itemsToScroll: 1,
                    minWidth: 768
                }
            ],
            speed: 700,
            easing: "linear",
            autoplay: true,
            autoplayDirection: "forward",
            autoplayDelay: 5000,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.feedbackContainer,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.feedbackCardContiner,
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: "../assets/Landing/comma.svg",
                                className: styles.comma
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: "../assets/Landing/bgElement.svg",
                                className: styles.bgElement
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.content,
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.contentHeading,
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "Rohit, Delhi"
                                            }),
                                            /*#__PURE__*/ _jsx("img", {
                                                src: "../assets/Landing/bgHeading.png"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.contentInfo,
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "I am so glad I discovered PillUp! Their online pharmacy service has been a game-changer for me. Not only do they offer genuine medicines, but their prices are also incredibly competitive. It’s a one-stop-shop for all my medication needs."
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: styles.rating,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.ratingLeft,
                                                        children: "rating"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.ratingRight,
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: styles.profileContainer
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.feedbackContainer,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.feedbackCardContiner,
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: "../assets/Landing/comma.svg",
                                className: styles.comma
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: "../assets/Landing/bgElement.svg",
                                className: styles.bgElement
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.content,
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.contentHeading,
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "Rohit, Delhi"
                                            }),
                                            /*#__PURE__*/ _jsx("img", {
                                                src: "../assets/Landing/bgHeading.png"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.contentInfo,
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "I am so glad I discovered PillUp! Their online pharmacy service has been a game-changer for me. Not only do they offer genuine medicines, but their prices are also incredibly competitive. It’s a one-stop-shop for all my medication needs."
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: styles.rating,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.ratingLeft,
                                                        children: "rating"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.ratingRight,
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: styles.profileContainer
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_FeedbackSlider = ((/* unused pure expression or super */ null && (FeedbackSlider)));

;// CONCATENATED MODULE: ./components/VideoSlider.js





const videoLinks = [
    {
        id: 2,
        title: "PillUp Customer Story | Dr. Aruna Broota",
        linkId: "fymHY2CRsD8",
        name: "Aruna",
        info: "Psychologist",
        age: "60"
    },
    {
        id: 2,
        title: "PillUp Customer Story | Sanjana",
        linkId: "m7Jcg6pkjIw",
        name: "Sanjana",
        info: "Working Professional",
        age: "35"
    },
    {
        id: 3,
        title: "PillUp Customer Story | Fawzan",
        linkId: "VrFLwZfic7o",
        name: "Fawzan",
        info: "Associate VP",
        age: "29"
    },
    {
        id: 4,
        title: "PillUp Customer Story | Sarthak",
        linkId: "z8i4ayMzXIg",
        name: "Sarthak",
        info: "College student and Fitness Enthusiast",
        age: "26"
    }
];
const VideoSlider = ()=>{
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    const [video, setVideo] = useState("fymHY2CRsD8");
    return /*#__PURE__*/ _jsx("div", {
        className: styles.slider_container,
        children: /*#__PURE__*/ _jsx(ReactSimplyCarousel, {
            activeSlideIndex: activeSlideIndex,
            onRequestChange: setActiveSlideIndex,
            itemsToShow: 1,
            itemsToScroll: 1,
            forwardBtnProps: {
                className: styles.forwardBtn,
                children: /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "../assets/sliderRightArrowBrown.svg",
                        className: styles.sliderArrow
                    })
                })
            },
            backwardBtnProps: {
                className: styles.backwardBtn,
                children: /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "../assets/sliderLeftArrowBrown.svg",
                        className: styles.sliderArrow
                    })
                })
            },
            responsiveProps: [
                {
                    itemsToShow: 1,
                    itemsToScroll: 1,
                    minWidth: 768
                }
            ],
            speed: 500,
            easing: "linear",
            children: videoLinks ? videoLinks.map((param)=>{
                let { id , info , linkId , name  } = param;
                return /*#__PURE__*/ _jsxs("div", {
                    className: styles.videoBoxContainer,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.videoBox,
                            style: {
                                filter: "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.27))"
                            },
                            children: /*#__PURE__*/ _jsx("iframe", {
                                width: "100%",
                                height: "100%",
                                src: "https://www.youtube.com/embed/".concat(linkId),
                                title: "YouTube video player",
                                frameBorder: "0",
                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                allowFullScreen: true
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.contentInfo,
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    style: ginger.style,
                                    children: name
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    children: info
                                })
                            ]
                        })
                    ]
                }, id);
            }) : ""
        })
    });
};
/* harmony default export */ var components_VideoSlider = ((/* unused pure expression or super */ null && (VideoSlider)));

;// CONCATENATED MODULE: ./components/PostSlider.js




const PostSlider_PostSlider = (param)=>{
    let { data  } = param;
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    const [imgs, setImgs] = useState(data);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.slider_container,
        children: /*#__PURE__*/ _jsx(ReactSimplyCarousel, {
            activeSlideIndex: activeSlideIndex,
            onRequestChange: setActiveSlideIndex,
            itemsToShow: 1,
            itemsToScroll: 1,
            forwardBtnProps: {
                className: styles.forwardBtn,
                children: /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "../assets/sliderRightArrowBrown.svg",
                        className: styles.sliderArrow
                    })
                })
            },
            backwardBtnProps: {
                className: styles.backwardBtn,
                children: /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "../assets/sliderLeftArrowBrown.svg",
                        className: styles.sliderArrow
                    })
                })
            },
            responsiveProps: [
                {
                    itemsToShow: 1,
                    itemsToScroll: 1,
                    minWidth: 768
                }
            ],
            speed: 700,
            easing: "linear",
            autoplay: true,
            autoplayDirection: "forward",
            autoplayDelay: 3000,
            children: data ? data.map((items)=>{
                return /*#__PURE__*/ _jsx("div", {
                    className: styles.postContainer,
                    children: /*#__PURE__*/ _jsx("img", {
                        src: items.attributes ? "https://blogcms.pillupreminder.com".concat(items.attributes.url) : ""
                    })
                }, items.id);
            }) : ""
        })
    });
};
/* harmony default export */ var components_PostSlider = ((/* unused pure expression or super */ null && (PostSlider_PostSlider)));

;// CONCATENATED MODULE: ./components/PostContent.js





const PostContent = (param)=>{
    let { data  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.postContent,
        children: data ? data.map((type)=>{
            if (type.__component == "shared.rich-text") {
                return /*#__PURE__*/ _jsx(ReactMarkdown, {
                    children: type.body
                }, type.id);
            }
            if (type.__component == "shared.media" && type.file.data) {
                return /*#__PURE__*/ _jsx("div", {
                    className: styles.imgContainer,
                    children: /*#__PURE__*/ _jsx("img", {
                        src: type.file && type.file.data ? "https://blogcms.pillupreminder.com".concat(type.file.data.attributes.url) : ""
                    })
                }, type.id);
            }
            if (type.__component == "shared.slider" && type.files.data) {
                return /*#__PURE__*/ _jsx(PostSlider, {
                    data: type.files.data
                }, type.id);
            }
            if (type.__component == "shared.quote") {
                return /*#__PURE__*/ _jsxs("div", {
                    className: styles.qouteContent,
                    style: smithyxt.style,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.qouteContainer,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.comma,
                                    id: styles.upperComma,
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/assets/Blogs/comma1.svg"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.content,
                                    children: [
                                        " ",
                                        type.body
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.comma,
                                    id: styles.lowerComma,
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/assets/Blogs/comma3.svg"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.writer,
                            children: [
                                "- ",
                                type.title
                            ]
                        })
                    ]
                }, type.id);
            }
        }) : ""
    });
};
/* harmony default export */ var components_PostContent = ((/* unused pure expression or super */ null && (PostContent)));

;// CONCATENATED MODULE: ./components/index.js

















/***/ }),

/***/ 6222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"benefitCard":"Benefit_benefitCard__ZIz3Y","imgContainer":"Benefit_imgContainer__c44Gt","contentData":"Benefit_contentData__qDf3N"};

/***/ }),

/***/ 76680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__8zu7p","imgContainer":"BlogCard_imgContainer__7LCrR","tag":"BlogCard_tag__yubqq","title":"BlogCard_title__5M85_","date":"BlogCard_date__qd3xd"};

/***/ }),

/***/ 15769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__N2yPh","videoContainer":"Hero_videoContainer__BVOYP","char":"Hero_char__SICer","slider":"Hero_slider__3nYM4"};

/***/ }),

/***/ 50412:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"HorizontalSlider_outerContainer__xXOj1","container":"HorizontalSlider_container__1KqoA","panel":"HorizontalSlider_panel__7QqX4","leftSection":"HorizontalSlider_leftSection__Pvnxz","slide2Img":"HorizontalSlider_slide2Img__W6tnR","slide3Img":"HorizontalSlider_slide3Img__ucgtF","rightSection":"HorizontalSlider_rightSection__WnG21","count":"HorizontalSlider_count__IaTtU","heading":"HorizontalSlider_heading__ey0f5","info":"HorizontalSlider_info__lWHhC","howItWorksbtn":"HorizontalSlider_howItWorksbtn__8uXRF","scrollbtn":"HorizontalSlider_scrollbtn__pmtr_","section1":"HorizontalSlider_section1__YBvXG","section2":"HorizontalSlider_section2__Dl___","section3":"HorizontalSlider_section3__Bxnrz","section4":"HorizontalSlider_section4__Vgq7Z"};

/***/ }),

/***/ 56802:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"HowItWorksSlider_outerContainer__u9o0j","container":"HowItWorksSlider_container___4zO1","howItWorksLabel":"HowItWorksSlider_howItWorksLabel__I3JSI","panel":"HowItWorksSlider_panel__MIK5D","leftSection":"HowItWorksSlider_leftSection__fqTOu","contentContainer":"HowItWorksSlider_contentContainer__7nbz7","count":"HowItWorksSlider_count__YCfSh","heading":"HowItWorksSlider_heading__cc_F_","info":"HowItWorksSlider_info__ECIA8","rightSection":"HowItWorksSlider_rightSection__FenQy","imgContainer":"HowItWorksSlider_imgContainer__q9VkF","section1":"HowItWorksSlider_section1__5824T","section2":"HowItWorksSlider_section2__SZBy3","section3":"HowItWorksSlider_section3__29Tet","section4":"HowItWorksSlider_section4__fdYYC"};

/***/ }),

/***/ 57246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__VJtHQ","cardContainer":"Partners_cardContainer__1lE8_","card":"Partners_card__HJoan","logo":"Partners_logo__Fo1ko"};

/***/ })

}]);